import { Divider } from '@ksyos/design-system';
import { translateKey } from '../../../../../translate';
import { HeaderDivider } from '../../../../elements/common';
import { ReadCustomControlData } from '../../../../elements/forms/ReadCustomControlData';

interface ITooV1SupervisionReadFields {
    assessmentBiometrics: string | null;
    assessmentCompleteness: string | null;
    assessmentDiagnosis: string | null;
    assessmentQuestion: string | null;
    remarkBiometrics: string | null;
    remarkGrading: string | null;
}
export function TooV1SupervisionReadFields(props: ITooV1SupervisionReadFields) {
    const {
        assessmentBiometrics,
        assessmentCompleteness,
        remarkBiometrics,
        assessmentQuestion,
        assessmentDiagnosis,
        remarkGrading,
    } = props;

    return (
        <>
            <HeaderDivider text={translateKey('activityTypeEnum.biometrics')} />
            <ReadCustomControlData
                label={translateKey('tooSupervision.assessmentBiometrics')}
                value={
                    assessmentBiometrics
                        ? translateKey(`supervisorsAssessmentBiometricsEnum.${assessmentBiometrics}`)
                        : ''
                }
            />
            <ReadCustomControlData
                label={translateKey('tooSupervision.assessmentCompleteness')}
                value={assessmentCompleteness || ''}
            />
            <ReadCustomControlData
                label={translateKey('tooSupervision.remarkBiometrics')}
                value={remarkBiometrics || ''}
            />
            <Divider />
            <HeaderDivider text={translateKey('diagnosticReport.findings')} />
            <ReadCustomControlData
                label={translateKey('tooSupervision.assessmentQuestion')}
                value={
                    assessmentQuestion ? translateKey(`supervisorsAssessmentBiometricsEnum.${assessmentQuestion}`) : ''
                }
            />
            <ReadCustomControlData
                label={translateKey('tooSupervision.assessmentDiagnosis')}
                value={
                    assessmentDiagnosis
                        ? translateKey(`supervisorsAssessmentBiometricsEnum.${assessmentDiagnosis}`)
                        : ''
                }
            />
            <ReadCustomControlData
                label={translateKey('tooSupervision.remarkGrading')}
                value={remarkGrading || ''}
            />
        </>
    );
}
